import { useInfiniteQuery } from '@tanstack/react-query';
import axios from 'axios';
import { GetPeopleYouMayKnowV1Response } from '@/../../server/types/apiTypes';

export async function fetchPeopleYouMayKnow(page: number) {
  const TAKE = 20;
  const skip = page * TAKE;

  const response = await axios.get<GetPeopleYouMayKnowV1Response>(
    `/api/social/getPeopleYouMayKnowV1?take=${TAKE}&skip=${skip}`,
  );

  if (response.data.success && response.data.data) {
    const { total, list } = response.data.data;
    return {
      hasMore: total > TAKE + skip,
      list,
    };
  }
  return {
    hasMore: false,
    list: [],
  };
}

export const usePeopleYouMayKnowInfiniteQuery = () => {
  return useInfiniteQuery({
    queryKey: ['peopleYouMayKnow'],
    queryFn: ({ pageParam }) => fetchPeopleYouMayKnow(pageParam),
    getNextPageParam: (lastPage, allPages, lastPageParam) => {
      if (lastPage.hasMore) {
        return lastPageParam + 1;
      }
      return undefined;
    },
    initialPageParam: 0,
  });
};
